const publicAsset = (path) => `${process.env.PUBLIC_URL || ""}${path}`;

export const LOGO_URL = publicAsset("/innospeq-logo.svg");
export const DEVICES_MOCKUP_URLS = {
  light: publicAsset("/devices_light.png"),
  dark: publicAsset("/devices_dark.png"),
};
export const STOCK_IMAGE_URLS = {
  construction: publicAsset("/stock/construction_bw_blur.jpg"),
  office: publicAsset("/stock/office_bw_blur.jpg"),
  production: publicAsset("/stock/production_bw_blur.jpg"),
  logistics: publicAsset("/stock/logistics_bw_blur.jpg"),
  mall: publicAsset("/stock/mall_bw_blur.jpg"),
};
export const TEAM_AVATAR_URLS = [
  publicAsset("/team/daniel.webp"),
  publicAsset("/team/jens.webp"),
  publicAsset("/team/patrick.webp"),
  publicAsset("/team/isa.webp"),
  publicAsset("/team/tom.webp"),
];
